export const textbox = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Lower Third</title>

    <style>
      * {
        box-sizing: border-box;
      }
      @font-face {
        font-family: "TenantFont";
        src: url(data:font/truetype;charset=utf-8;base64,{BRANDING_FONT_BASE64})
          format("truetype");
      }
      html,
      body,
      .textbox #fullheight {
        min-height: 100% !important;
        height: 100%;
        padding: 0;
        margin: 0;
        /* Change font for Clients in the future */
        font-family: "Roboto", sans-serif;
      }

      .textbox {
        max-width: 1920px;
        min-width: 1920px;
        max-height: 1080px;
        width: 100%;
        height: 100%;

        padding: 80px;
        /* background: url("https://images.pexels.com/photos/1181605/pexels-photo-1181605.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"); */
        background-size: cover;
        background-repeat: no-repeat;
      }
      .textbox .frameContent {
        width: 100%;
        height: 100%;
        position: relative;
      }
      .textbox h2.frameTitle {
        margin: 0 0 16px 0;
        padding: 0;
        font-size: 42px;
        line-height: 60px;
        font-weight: 500;
        letter-spacing: 1px;
        text-align: left;
        font-family: "TenantFont", sans-serif !important;
      }
      .textbox span.frameSubtitle {
        font-size: 30px;
        line-height: 40px;
        font-weight: 300;
        text-align: left;
      }
      .textbox .text-box-small {
        padding: 40px;
        color: {BRANDING_PRIMARY_COLOR};
        bottom: 30px;
        max-width: 580px;
        left: 80px;
        position: absolute;
        display: inline-block;

        /* ************* Change Colors ****************** */

        /* Primary Color - #052635 */
        background: white;
        /* Accent Color - #f42b4f */
        border-left: 12px solid {BRANDING_ACCENT_COLOR};

        /* ************* Change Colors ****************** */
      }
    </style>
  </head>
  <body>
    <div class="textbox">

        <div class="frameContent">
          <div class="text-box-small">
            <h2 class="frameTitle">{TITLE}</h2>
            <span class="frameSubtitle">{DESCRIPTION}</span>
          </div>
        </div>
      </div>

  </body>
</html>`;

export const lowerThird = ` <!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>Lower Third</title>

<style>
  * {
    box-sizing: border-box;
  }
  @font-face {
    font-family: "TenantFont";
    src: url(data:font/truetype;charset=utf-8;base64,{BRANDING_FONT_BASE64})
      format("truetype");
  }
  html,
  body,
  .lowerThird #fullheight {
    min-height: 100% !important;
    height: 100%;
    padding: 0;
    margin: 0;
    /* Change font for Clients in the future */
    font-family: "Roboto", sans-serif;
  }

  .lowerThird {
    max-width: 1920px;
    min-width: 1920px;
    max-height: 1080px;
    width: 100%;
    height: 100%;

    padding: 80px;
    /* background: url("https://images.pexels.com/photos/1181605/pexels-photo-1181605.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"); */
    background-size: cover;
    background-repeat: no-repeat;
  }
  .lowerThird .frameContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .lowerThird h2.frameTitle {
    margin: 0;
    padding: 0;
    font-size: 58px;
    line-height: 80px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: left;
    font-family: "TenantFont", sans-serif !important;
  }
  .lowerThird span.frameSubtitle {
    font-size: 28px;
    line-height: 38px;
    font-weight: 300;
    text-align: left;
  }
  .lowerThird .lower-third {
    padding: 18px 160px 28px 30px;
    color: {BRANDING_PRIMARY_COLOR};
    /* margin-bottom: 30px; */
    /* margin-left: 80px; */
    bottom: 30px;
    left: 80px;
    position: absolute;
    display: inline-block;

    /* ************* Change Colors ****************** */

    /* Primary Color - #052635 */
    background: #ffffff;
    /* Accent Color - #f42b4f */
    border-left: 12px solid {BRANDING_ACCENT_COLOR};

    /* ************* Change Colors ****************** */
  }
</style>
</head>
<body>
    <div class="lowerThird">
      <div class="frameContent">
        <div class="lower-third">
          <h2 class="frameTitle">{TITLE}</h2>
          <span class="frameSubtitle">{DESCRIPTION}</span>
        </div>
      </div>
    </div>
</body>
</html> `;
